import { getPassportInstance } from '@pubky/passport-client';
import { getPassportUrl } from '@/config/network';
import { PASSPORT_DEFAULT_INSTANCE } from '@/config/passport';

/** Public-key-only link; the signer must independently authorize the matching identity. */
export function getPassportProfileUrl(publicKey: string, instance?: string | null): string {
  const origin = instance || getPassportInstance(getPassportUrl() || PASSPORT_DEFAULT_INSTANCE);
  const url = new URL('/', origin);
  url.hash = `edit-profile=${encodeURIComponent(publicKey)}`;
  return url.toString();
}
